import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import CrearSolicitudEspecial from "../modals/CreaSolicitudEspecial";
import ConsolidadoEspeciales from "./ConsolidadoEspeciales";
import InfoEspecialesAyR from "./InfoEspecialesAyR";

const cookie = new Cookies();

function InfoEspeciales() {
  const tipoUsuario = parseInt(cookie.get("tipo_Usuario"));
  const userId = cookie.get("id");
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");

  const [paginaActual, setPaginaActual] = useState(1);
  const porPagina = 10;

  const urlendpoint =
    tipoUsuario === 3
      ? `https://educacionapi.azurewebsites.net/api/ObtenerTodos/0/0`
      : "https://educacionapi.azurewebsites.net/api/ObtenerTodos/0/0";

  useEffect(() => {
    axios({
      auth: { username: "webapp", password: "762tsfsy9826kk87ytttsf" },
      method: "get",
      url: urlendpoint,
    })
      .then((response) => {
        setList(response.data);
      })
      .catch((error) => {
        console.error("Error al obtener solicitudes:", error);
      });
  }, [urlendpoint]);

  const filteredResults = search
    ? list.filter((item) =>
        item.nombreCliente.toLowerCase().includes(search.toLowerCase())
      )
    : list;

  const totalPaginas = Math.ceil(filteredResults.length / porPagina);
  const indexUltimo = paginaActual * porPagina;
  const indexPrimero = indexUltimo - porPagina;
  const datosPagina = filteredResults.slice(indexPrimero, indexUltimo);

  const handleAnterior = () => {
    setPaginaActual((prev) => Math.max(prev - 1, 1));
  };

  const handleSiguiente = () => {
    setPaginaActual((prev) => Math.min(prev + 1, totalPaginas));
  };

  useEffect(() => {
    setPaginaActual(1); // Reinicia la paginación al buscar
  }, [search]);

  return (
    <Fragment>
      <div className="container">
        <div className="text-center">
          <div className="container-fluid">
            <div className="card shadow mb-12">
              <div className="card-header py-12">
                <h6 className="m-0 font-weight-bold text-primary">
                  Solicitudes Propias
                </h6>
                <hr />
              </div>
              <div className="card-body">
                <CrearSolicitudEspecial />
                <br />

                <input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  type="text"
                  placeholder="Buscar por nombre del cliente"
                  className="form-control"
                />

                <div className="table-responsive mt-3">
                  <table
                    className="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellSpacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Nombre cliente</th>
                        <th>Línea de servicio</th>
                        <th>Estado</th>
                        <th>Fecha Creación</th>
                        <th>Consultar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {datosPagina.length > 0 ? (
                        datosPagina.map((item) => {
                          const fecha = new Date(item.fechaCreacion);
                          return (
                            <tr key={item.id}>
                              <td>{item.id}</td>
                              <td>{item.nombreCliente}</td>
                              <td>{item.lineaServicio}</td>
                              <td>{item.estados}</td>
                              <td
                                className={`text-light ${
                                  item.vencido === 0
                                    ? "bg-warning"
                                    : "bg-danger"
                                }`}
                              >
                                {fecha.toLocaleDateString("es-CO")}
                              </td>
                              <td>
                                <ConsolidadoEspeciales
                                  id={item.id}
                                  lineaServicio={item.lineaServicio}
                                  titulo={item.titulo}
                                  descripcion={item.descripcion}
                                  estado={item.estado}
                                  fechaCreacion={item.fechaCreacion}
                                  nombreCliente={item.nombreCliente}
                                  adjunto1={item.adjunto}
                                  usuarioId={item.usuarioId}
                                  observaciones={item.observaciones}
                                  usuario={item.nombre}
                                />
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center text-muted">
                            No hay resultados
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {filteredResults.length > porPagina && (
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <button
                      className="btn btn-outline-primary"
                      onClick={handleAnterior}
                      disabled={paginaActual === 1}
                    >
                      ← Anterior
                    </button>
                    <span className="mx-3">
                      Página {paginaActual} de {totalPaginas}
                    </span>
                    <button
                      className="btn btn-outline-primary"
                      onClick={handleSiguiente}
                      disabled={paginaActual === totalPaginas}
                    >
                      Siguiente →
                    </button>
                  </div>
                )}
                <br></br>
                {/* Mostrar AyR solo si es tipo 2 o 3 */}
                {tipoUsuario === 2 || tipoUsuario === 3 ? (
                  <InfoEspecialesAyR />
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
    </Fragment>
  );
}

export default InfoEspeciales;
